import '../styles/App.css';
import * as API from '../appAPI/api';
import { Route, Routes } from 'react-router-dom';
import HomePage from './homePage/HomePage';
import AdminPage from './adminPage/AdminPage';
import { useState, useEffect } from 'react';

sessionStorage.currentOrders = JSON.stringify([
      {
          "id": "40305066-1640-d451-e947-f648312a1841",
          "value": {
              "text": "information about order",
              "phone": "01285464570"
          },
          "state": "pending",
          "time": "7 : 54",
          "price": "5",
          "date": new Date(),
          "employer": "",
          "counter": 0,
          "runningDate": "2023-01-18T08:45:20.178Z"
      }
    ])
    
function App() {
  const [currentRunningOrders, setCurrentRunningOrders] = useState([]);
  const [currentOrders, setCurrentOrders] = useState([]);
  const [clientInfo, setClientInfo] = useState('');
  const [employeesAndvehicles, setemployeesAndvehicles] = useState({employees: [], vehicles: []});
  const [currentControls, setCurrentControls] = useState('')

  useEffect(() => {
    
    if (sessionStorage.currentOrders) {
      setCurrentOrders(
        JSON.parse(sessionStorage.currentOrders)
      );
      if (sessionStorage.currentRunningOrders) {
        setCurrentRunningOrders(
          JSON.parse(sessionStorage.currentRunningOrders)
        )
    }
    }else {
      sessionStorage.currentOrders = "[]"
    }

    let counter

    (async () => {
      const data = await API.getControls();
      let controls = data.controls;
      let clients = data.clients
      setCurrentControls(controls);

      if (sessionStorage.employeesAndvehicles) {
        let storageData = JSON.parse(sessionStorage.employeesAndvehicles)
        let storageEM_ID = storageData.employees.map((e) => e.id);
        let storageMC_ID = storageData.vehicles.map((m) => m.id);
  
        let employees = storageData.employees;
        let vehicles = storageData.vehicles;
        const date = new Date();
  
        for (let x of controls.employees) {
          if (!storageEM_ID.includes(x.id)) {
            x.state = 'off';
            x.vehicle = '';
            x.orders = [];
            x.finishedOrders = [];
            x.finishedOrdersContainer = [];
            x.date = date;
            employees.push(x)
          }else {
            employees = employees.map((y) => {
              if (y.id === x.id ) {
                y.name = x.name
              }
              return y
            }) 
          }
        }
  
        for (let x of controls.vehicles) {
          if (!storageMC_ID.includes(x.id)) {
            x.state = 'off';
            x.employer = '';
            x.finishedOrders = [];
            x.finishedOrdersContainer = [];
            x.date = date;
            x.expenses =  {
              petrol: '',
              oil: '',
              repairs: ''}
            vehicles.push(x)
          }else {
            vehicles = vehicles.map((y) => {
              if (y.id === x.id ) {
                y.name = x.name
              }
              return y
            }) 
          }
        }
        
        setemployeesAndvehicles( {employees, vehicles} );
        sessionStorage.employeesAndvehicles = JSON.stringify({employees, vehicles})
  
      }else {
        const date = new Date();
        const employees = controls.employees.map((employer) => {
        employer.state = 'off';
        employer.vehicle = '';
        employer.orders = [];
        employer.finishedOrders = [];
        employer.finishedOrdersContainer = [];
        employer.date = date;
        return employer;
      })
        const vehicles = controls.vehicles.map((vehicle) => {
        vehicle.state = 'off';
        vehicle.employer = '';
        vehicle.finishedOrders = [];
        vehicle.finishedOrdersContainer = [];
        vehicle.date = date;
        vehicle.expenses =  {
          petrol: '',
          oil: '',
          repairs: ''}
        return vehicle
      })
      setemployeesAndvehicles({employees, vehicles});
      sessionStorage.employeesAndvehicles = JSON.stringify({employees, vehicles})
    }
  
      if (sessionStorage.clientInfo) {
        let storageData = JSON.parse(sessionStorage.clientInfo)
        let storageCL_ID = storageData.map((c) => c.id);
        const newClients = storageData;
  
        for (let x of clients) {
          if (!storageCL_ID.includes(x.id)) {
            newClients.push(x)
          }
        }

        setClientInfo(newClients)
        sessionStorage.clientInfo = JSON.stringify(newClients)
      }else {
        setClientInfo(clients)
        sessionStorage.clientInfo = JSON.stringify(clients)
      }
  
      counter = setInterval(() => {
        let newCurrentOrders = JSON.parse(sessionStorage.currentOrders);
        
        for (let x = 0; x <= currentRunningOrders.length-1; x++) {
          newCurrentOrders = newCurrentOrders.map((o) => {
            if (o.id === currentRunningOrders[x]) {

              function diff_minutes(dt2, dt1) {
                let diff =(dt2.getTime() - dt1.getTime()) / 1000;
                diff /= 60;
                return Math.abs(Math.round(diff));
              }

              let dt1 = new Date(o.runningDate);
              let dt2 = new Date()

              o.counter = diff_minutes(dt1, dt2);
              if (o.counter >= controls.counterLength) {
                o.state = 'warning';
              }else if (o.counter <= controls.counterLength && o.state === 'warning') {
                o.state = 'running';
              }
            }
            return o
          });
          updateCurrentOrders(newCurrentOrders)
        }
      }, 1000)
      
    })()
    
    
    return () => clearInterval(counter)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRunningOrders.length, currentOrders.length])

  const updateCurrentOrders = (data) => {
    
    setCurrentOrders(data);
    sessionStorage.currentOrders = JSON.stringify(data);
  }
    
  const handleCurrentRunningOrders = (orderID, action) => {
    let newCRO = [...currentRunningOrders];
    switch (action) {
      case 'add':
        if (!newCRO.includes(orderID)) newCRO.push(orderID);
        break;
      case 'remove':
        newCRO = currentRunningOrders.filter((oID) => orderID !== oID);
        break;
      default:
    }
    
    setCurrentRunningOrders(newCRO);
    sessionStorage.currentRunningOrders = JSON.stringify(newCRO);
  }

  const handleClientInfo = (data) => {
    setClientInfo(data);
    sessionStorage.clientInfo = JSON.stringify(data)
  }

  const handleEmployerAndvehicle = (data) => {
    setemployeesAndvehicles(data);
    sessionStorage.employeesAndvehicles = JSON.stringify(data)
  }

  const handleCurrentControls = (controls, type) => {
      
    if (sessionStorage.employeesAndvehicles && type === 'updateEmployees') {
      let storageData = JSON.parse(sessionStorage.employeesAndvehicles)
      let storageEM_ID = storageData.employees.map((e) => e.id);
 
      let employees = storageData.employees;
      let vehicles = storageData.vehicles;

      let newControls = JSON.parse(JSON.stringify(controls))   

      for (let x of newControls.employees) {
        if (!storageEM_ID.includes(x.id)) {
          x.state = 'off';
          x.vehicle = '';
          x.orders = [];
          x.finishedOrders = [];
          x.finishedOrdersContainer = [];
          employees.push(x)
        }else {
          employees = employees.map((y) => {
            if (y.id === x.id ) {
              y.name = x.name
            }
            return y
          }) 
        }
      }
      
      setemployeesAndvehicles( {employees, vehicles} );
      sessionStorage.employeesAndvehicles = JSON.stringify({employees, vehicles})
    }

    if (sessionStorage.employeesAndvehicles && type === 'updateVehicles') {
      let storageData = JSON.parse(sessionStorage.employeesAndvehicles)
      let storageMC_ID = storageData.vehicles.map((m) => m.id);
 

      let employees = storageData.employees;
      let vehicles = storageData.vehicles;

      let newControls = JSON.parse(JSON.stringify(controls))   
    
      for (let x of newControls.vehicles) {
        if (!storageMC_ID.includes(x.id)) {
          x.state = 'off';
          x.employer = '';
          x.finishedOrders = [];
          x.finishedOrdersContainer = [];
          x.expenses =  {
            petrol: '',
            oil: '',
            repairs: ''}
          vehicles.push(x)
        }else {
          vehicles = vehicles.map((y) => {
            if (y.id === x.id ) {
              y.name = x.name
            }
            return y
          }) 
        }
      }
      
      setemployeesAndvehicles( {employees, vehicles} );
      sessionStorage.employeesAndvehicles = JSON.stringify({employees, vehicles})
    }


    setCurrentControls(controls);
    API.setControls(controls);
  }
   
  return (
    <div className="App">
      {!currentControls &&
      <h1 
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >Loading . . . </h1>}
      
      {currentControls && <Routes>
        <Route exact path='/delivery-assistant/' element={
          <HomePage 
            updateCurrentOrders={updateCurrentOrders}
            currentOrders={currentOrders}
            handleCurrentRunningOrders={handleCurrentRunningOrders} 
            assistantPassword={currentControls.assistantPassword}
            clientInfo={clientInfo}
            handleClientInfo={handleClientInfo}
            percentage={currentControls.percentage}
            employeesAndvehicles={employeesAndvehicles}
            handleEmployerAndvehicle={handleEmployerAndvehicle}
          />
        } />
        <Route exact path='/admin' element={
          <AdminPage 
            controls={currentControls}
            handleCurrentControls={handleCurrentControls}
            currentControls={currentControls}
            handleClientInfo={handleClientInfo}
          />
        } />
      </Routes>}
    </div>
  );
}

export default App;